// extracted by mini-css-extract-plugin
export default {"menu":"index-module--menu--XFEdu"};